import { Container } from '@mui/material';
import { Box } from '@mui/system';

export const MainPage = () => {
    return <Box sx={{ bgColor: 'black' }}>
        <Container maxWidth={false} disableGutters={true} style={{ flexDirection: 'column', backgroundColor: 'black', justifyContent: 'center', minHeight: 1000 }}>
            <div style={{ textAlign: 'center' }}>
                <img width={400} height={200} src='./assets/cdx_logo_v.svg' />
            </div>
        </Container>
    </Box>;
};
